import React, { Fragment } from 'react';

import DebugPanel from './DebugPanel';

import './App.scss';

// NOTE: this component should init global styles, meta (helmet), and other staff..

class App extends React.Component {
  render() {
    return (
      <Fragment>
        {this.props.children}
        <DebugPanel />
      </Fragment>
    );
  }
}

export default App;
